/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetSupportTicketQueryResponse, GetSupportTicketPathParams, GetSupportTicket400, GetSupportTicket401, GetSupportTicket403, GetSupportTicket404, GetSupportTicket409, GetSupportTicket500 } from "../../types/supportController/GetSupportTicket.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetSupportTicketUrl(id: GetSupportTicketPathParams["id"]) {
  const res = { method: 'GET', url: `/api/support/tickets/${id}` as const }
  return res
}

/**
 * @summary Get support ticket by ID
 * {@link /api/support/tickets/:id}
 */
export async function getSupportTicket(id: GetSupportTicketPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSupportTicketQueryResponse, ResponseErrorConfig<GetSupportTicket400 | GetSupportTicket401 | GetSupportTicket403 | GetSupportTicket404 | GetSupportTicket409 | GetSupportTicket500>, unknown>({ method : "GET", url : getGetSupportTicketUrl(id).url.toString(), ... requestConfig })
  return res.data
}